import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { stationsMaster } from '../data/stations';
import { externalLinkBaseUrl } from '../services/urlService';
import { eventsEmit, lineNameAbbr } from '../services/appboxService';
import timetableIcon from '../assets/images/mainline/station/ic_timetable_station.svg';
import fareIcon from '../assets/images/mainline/station/ic_fare_station.svg';
import externalLinkIcon from '../assets/images/stations/transfers/ic_external_link.svg';
import stationMapIcon from '../assets/images/mainline/station/ic_station_map_station.svg';
import rapid from '../assets/images/mainline/station/rapid.svg';
import comR from '../assets/images/mainline/station/com_r.svg';
import semiR from '../assets/images/mainline/station/semi_r.svg';
import local from '../assets/images/mainline/station/local.svg';
import stationNumber01 from '../assets/images/mainline/station/number/01.svg';
import stationNumber02 from '../assets/images/mainline/station/number/02.svg';
import stationNumber03 from '../assets/images/mainline/station/number/03.svg';
import stationNumber04 from '../assets/images/mainline/station/number/04.svg';
import stationNumber05 from '../assets/images/mainline/station/number/05.svg';
import stationNumber06 from '../assets/images/mainline/station/number/06.svg';
import stationNumber07 from '../assets/images/mainline/station/number/07.svg';
import stationNumber08 from '../assets/images/mainline/station/number/08.svg';
import stationNumber09 from '../assets/images/mainline/station/number/09.svg';
import stationNumber10 from '../assets/images/mainline/station/number/10.svg';
import stationNumber11 from '../assets/images/mainline/station/number/11.svg';
import stationNumber12 from '../assets/images/mainline/station/number/12.svg';
import stationNumber13 from '../assets/images/mainline/station/number/13.svg';
import stationNumber14 from '../assets/images/mainline/station/number/14.svg';
import stationNumber15 from '../assets/images/mainline/station/number/15.svg';
import stationNumber16 from '../assets/images/mainline/station/number/16.svg';
import stationNumber17 from '../assets/images/mainline/station/number/17.svg';
import stationNumber18 from '../assets/images/mainline/station/number/18.svg';
import stationNumber19 from '../assets/images/mainline/station/number/19.svg';
import stationNumber20 from '../assets/images/mainline/station/number/20.svg';

const StationDetail = (props) => {
  useEffect(() => {
    import('../assets/stylesheets/mainline/station.css')
      .then(() => {
      })
      .catch(err => console.error("CSSの読み込みエラー", err));
  }, []);

  const handleBack = () => {
    window.history.back();
  };

  const stationNumberSvgs = {
    '01': stationNumber01,
    '02': stationNumber02,
    '03': stationNumber03,
    '04': stationNumber04,
    '05': stationNumber05,
    '06': stationNumber06,
    '07': stationNumber07,
    '08': stationNumber08,
    '09': stationNumber09,
    '10': stationNumber10,
    '11': stationNumber11,
    '12': stationNumber12,
    '13': stationNumber13,
    '14': stationNumber14,
    '15': stationNumber15,
    '16': stationNumber16,
    '17': stationNumber17,
    '18': stationNumber18,
    '19': stationNumber19,
    '20': stationNumber20,
  };

  const stationNumberSvg = (station) => {
    return stationNumberSvgs[station.number] || null;
  };

  const stationStopTypesSvgs = {
    'local': local,
    'semi_r': semiR,
    'com_r': comR,
    'rapid': rapid,
  };
  const stationStopTypesSvg = (stopType) => {
    return stationStopTypesSvgs[stopType] || null;
  };

  const stationInfo = (station) => {
    return (
      <div className="station-info">
        <div className="station-name">
          <img
            className="station-number"
            src={stationNumberSvg(station)}
            alt={`駅番号 ${station.number}`}
          />
          <div className="station-text">
            <p className="hurigana">{station.furigana}</p>
            <h1 className="name">{station.name}</h1>
          </div>
        </div>
        <div className="train-type">
          <p>停車する電車</p>
          <div className="train-type-icons">
            {station.stopTypes.map((stopType, index) => (
              <img
                key={index}
                className={stopType}
                src={stationStopTypesSvg(stopType)}
                alt={stopType}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }

  const clickEvent = (locationHref, eventName, eventValue) => {
    eventsEmit(eventName, eventValue)

    location.href = locationHref
  };

  const stationMenu = (station) => {
    return (
      <div className="station-menu">
        <div className="time-table">
          <div className="menu-title">
            <img src={timetableIcon} alt="時刻表アイコン" />
            <h2>時刻表</h2>
          </div>
          {station.timeTables.down.weekdays && (
            <div className="menu-button">
              <p>下り（つくば方面）</p>
              <div className="button-section">
                <button onClick={ () => clickEvent(station.timeTables.down.weekdays, 'station_info.timetable.week.down', { station: station.stationId }) }>平日</button>
                <button onClick={ () => clickEvent(station.timeTables.down.holidays, 'station_info.timetable.holiday.down', { station: station.stationId }) }>土日・祝日</button>
              </div>
            </div>
          )}
          {station.timeTables.up.weekdays && (
            <div className="menu-button">
              <p>上り（秋葉原方面）</p>
              <div className="button-section">
                <button onClick={ () => clickEvent(station.timeTables.up.weekdays, 'station_info.timetable.week.up', { station: station.stationId }) }>平日</button>
                <button onClick={ () => clickEvent(station.timeTables.up.holidays, 'station_info.timetable.holiday.up', { station: station.stationId }) }>土日・祝日</button>
              </div>
            </div>
          )}
        </div>
        <div className="station-fare">
          <div className="fare-title">
            <img src={fareIcon} alt="運賃アイコン" />
            <h2>運賃</h2>
          </div>
          <div className="button-section">
            <button onClick={ () => clickEvent(station.fareTableUrl, 'station_info.fare_list', { station: station.stationId }) }>この駅からの運賃一覧</button>
          </div>
        </div>
      </div>
    )
  }

  const otherStationListItem = (lineName, timeTableUrl) => {
    return (
      <li key={lineName} className="list-item" onClick={ timeTableUrl ? () => clickEvent(timeTableUrl, 'station_info.transfer.other_company', { station: station.stationId, line_name: lineNameAbbr(lineName) }) : undefined }>
        <p>{lineName}</p>
        {timeTableUrl
          ? <img src={externalLinkIcon} alt="外部リンク" />
          : null
        }
      </li>
    )
  }

  const otherStationMenu = (station) => {
    const transferLines = station.transferLines
    const listItems = transferLines.map((company) => {
      const baseUrl =  externalLinkBaseUrl(company)

      return company.lines.map((line) => {
        const appUrl = line.timeTableUrlFromStation ? encodeURIComponent(line.timeTableUrlFromStation) : null
        const timeTableUrl = baseUrl && appUrl ? baseUrl + `&app=${appUrl}` : null
        return otherStationListItem(line.name, timeTableUrl)
      })
    }).flat()

    return (
      <div className="other-station-menu">
        <div className="menu-title">
          <img src={timetableIcon} alt="時刻表アイコン" />
          <h2>乗換路線</h2>
        </div>
        <ul className="station-list">
          {listItems}
        </ul>
    </div>
    )
  }

  const campusMap = (station) => {
    return (
      <div className="campus-map">
        <div className="map-title">
          <img src={stationMapIcon} alt="構内図アイコン" />
          <h2>構内図</h2>
        </div>
        <div className="map">
          <a href={`${process.env.BASE_URL}/station_layout/?station=${station.stationId}`}>
            <img src={`${process.env.BASE_URL}${station.stationLayoutPath}`} alt="構内図" />
          </a>
        </div>
      </div>
    )
  }

  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const isShowBackButton = query.get("return") == "true";

  const station = stationsMaster.find(s => s.stationId == props.match.params.station_id);

  return (
    <div>
      <main className="main-container">
        <div className="station-detail">
          {stationInfo(station)}
          <div className="menu">
            {stationMenu(station)}
            {station.transferLines ? otherStationMenu(station) : null}
            {campusMap(station)}
            <div className="tx-link">
              <a onClick={(event) => {
                  event.preventDefault();
                  clickEvent(station.officialSiteLink, 'station_info.official_web', {});
                }}
              >
                <p>つくばエクスプレス公式サイト</p>
                <img src={externalLinkIcon} alt="次へアイコン" />
              </a>
            </div>
          </div>
        </div>
      </main>
      {isShowBackButton && (
        <div className="footer">
          <button className="back-button" type='button' onClick={handleBack} style={{ cursor: 'pointer' }}>
            戻る
          </button>
        </div>
      )}
    </div>
  );
};

export default StationDetail;
